import { useCompany } from "@/api/services/admin/company";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { CompanyForm } from "@/features/company/components/CompanyForm";
import { convertCompanyResToForm } from "@/features/company/utils/converts";
import { AppRoutes } from "@/routes/config";
import { isNumber } from "@/utils/number";
import { getDynamicRoute } from "@/utils/url";
import { Box, Stack, styled } from "@mui/material";
import { FC, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

type TCompanyEditPageProps = {};

export const CompanyEditPage: FC<TCompanyEditPageProps> = () => {
  const formRef = useRef<{ submit: () => void }>(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: companyResult, isLoading, isError } = useCompany();
  const companyData = companyResult?.data;

  useEffect(() => {
    if (!id || !isNumber(id)) {
      navigate(AppRoutes.companyDuringContractList, { replace: true });
    }
  }, [id, navigate]);

  useEffect(() => {
    if (id && isNumber(id) && !isLoading && (isError || !companyData)) {
      navigate(AppRoutes.companyDuringContractList, { replace: true });
    }
  }, [id, isLoading, isError, companyData, navigate]);

  if (isLoading || !companyData) return <LoadingPage />;

  return (
    <CompanyEditWrapper sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <Stack gap={4}>
          <TopPage
            title="顧客の編集"
            description="事業者の基本情報および契約情報を変更できます。ステータスはトライアル終了日や解約日の翌日に自動的に変更されます。"
            backUrl={getDynamicRoute(AppRoutes.companyDetail, { id: companyData.id })}
            enablePageBack={false}
          />
          <CompanyForm previousData={convertCompanyResToForm(companyData)} ref={formRef} />
        </Stack>
      </Box>
    </CompanyEditWrapper>
  );
};

const CompanyEditWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
